import React, { useContext, useState, useEffect } from "react";
import { CreativeContext } from "./creatives/AddCreative";
import { campCreativeContext } from "./campaign/CreateCampaign";
// import previewMobile from "../assets/images/preview-frame.png";
import FullImagePreview from "../creativePreviews/FullImagePreview";
import FullVideoPreview from "../creativePreviews/FullVideoPreview";
import GalleryPreview from "../creativePreviews/GalleryPreview";
import HalfVideoPreview from "../creativePreviews/HalfVideoPreview";
import WebviewPreview from "../creativePreviews/WebviewPreview";
import VideowithBgPreview from "../creativePreviews/VideowithBgPreview";
import PromotedImagePreview from "../creativePreviews/PromotedImagePreview";
import PromotedVideoPreview from "../creativePreviews/PromotedVideoPreview";
import AnimationPreview from "../creativePreviews/AnimationPreview";
import NetworkAdPreview from "../creativePreviews/NetworkAdPreview";
import PromotedGalleryPreview from "../creativePreviews/PromotedGalleryPreview";
import CommentAdPreview from "../creativePreviews/CommentAdPreview";
import { campCreativeContext4 } from "./campaign/CreativeSelection";
import { campCreativeContext3 } from "./campaign/Date";
import { campCreativeContext2 } from "./campaign/Target";
import { reportCreativeContext } from "./reports/Reports";
import { campCreativeContext1 } from "./campaign/Start";
import { lineItemCreativeContext } from "./campaign/LineitemPreview";
import { creativewiseReportsContext } from "./Orders/CreativeWise";
import { NetworkAdContext } from "./networkads/Queued";
import { BlockedAdContext } from "./networkads/Blocked";
import { ApprovedAdContext } from "./networkads/Approved";
import { newStreamCreativeContext } from "./campaign/NewsStream";
import { lineitemCreativewiseReportsContext } from "./lineitemReport/LineitemCreativeWise";
import { InventoryContext } from "./inventory/Inventory";
import { BackfillReportContext } from "./reports/SpecialAdReport";
import VideoGalleryPreview from "../creativePreviews/VideoGalleryPreview";
import TextGalleryPreview from "../creativePreviews/TextGalleryPreview";
import BrandAdImagePreview from "../creativePreviews/BrandAdImagePreview";
import NewsImageFlip from "../creativePreviews/NewsImageFlip";
import NewsImageLogo from "../creativePreviews/NewsImageLogo";
import NewsImageDesc from "../creativePreviews/NewsImageDesc";
import VideoExpandable from "../creativePreviews/VideoExpandable";
import VideoSkippable from "../creativePreviews/VideoSkippable";
import VideoEndcard from "../creativePreviews/VideoEndcard";
import BottomRectangle from "../creativePreviews/BottomRectangle";
import SquareClassified from "../creativePreviews/SquareClassified";
import RectangleClassifieds from "../creativePreviews/RectangleClassifieds";
import FramePostPreview from "../creativePreviews/FramePostPreview";
import RecImagePreview from "../creativePreviews/RecImagePreview";
import RecPromotedPreview from "../creativePreviews/RecPromotedPreview";
import ListingsPreview from "../creativePreviews/JobListingsPreview";
import BusinessListingsPreview from "../creativePreviews/BusinessListingsPreview";
import SpecialsPreview from "../creativePreviews/SpecialsPreview";
function PreviewFrameEdit({ showPreview }) {
  const [preview, setPreview] = useState({});
  const creativePreview = useContext(CreativeContext);
  let campPreview = useContext(campCreativeContext);
  let reportPreview = useContext(reportCreativeContext);
  const campPreview4 = useContext(campCreativeContext4);
  const campPreview3 = useContext(campCreativeContext3);
  const campPreview2 = useContext(campCreativeContext2);
  const campPreview1 = useContext(campCreativeContext1);
  const lineItemPreview = useContext(lineItemCreativeContext);
  const creativewiseReport = useContext(creativewiseReportsContext);
  const networkPreview = useContext(NetworkAdContext);
  const blockedadPreview = useContext(BlockedAdContext);
  const approveddadPreview = useContext(ApprovedAdContext);
  const newStreamPreview = useContext(newStreamCreativeContext);
  const inventoryPreview = useContext(InventoryContext);
  const backfillreport = useContext(BackfillReportContext)
  const lineitemCreativeReportPreview = useContext(
    lineitemCreativewiseReportsContext
  );
  campPreview = campPreview
    ? campPreview
    : campPreview4
      ? campPreview4
      : campPreview3
        ? campPreview3
        : campPreview2
          ? campPreview2
          : newStreamPreview
            ? newStreamPreview
            : campPreview1
              ? campPreview1
              : lineItemPreview
                ? lineItemPreview
                : creativewiseReport
                  ? creativewiseReport
                  : lineitemCreativeReportPreview;
  useEffect(() => {
    if (creativePreview && creativePreview.preview) {
      setPreview(creativePreview.preview);
    } else if (campPreview && campPreview.campPreview) {
      setPreview(campPreview.campPreview);
    } else if (reportPreview) {
      setPreview(reportPreview.campPreview);
    } else if (networkPreview) {
      setPreview(networkPreview.campPreview);
    } else if (blockedadPreview) {
      setPreview(blockedadPreview.campPreview);
    } else if (approveddadPreview) {
      setPreview(approveddadPreview.campPreview);
    } else if (newStreamPreview) {
      setPreview(newStreamPreview.campPreview);
    } else if (lineItemPreview) {
      setPreview(lineItemPreview.campPreview);
    } else if (lineitemCreativeReportPreview) {
      setPreview(lineitemCreativeReportPreview.campPreview);
    } else if (inventoryPreview) {
      setPreview(inventoryPreview.preview);
    } else if(backfillreport){
      setPreview(backfillreport.preview)
    }
  }, [
    creativePreview,
    campPreview,
    reportPreview,
    networkPreview,
    blockedadPreview,
    approveddadPreview,
    inventoryPreview,
  ]);
  return (
    <div className="pt-2">
      <section className="preview-mobile">
        {/* {campPreview &&
          campPreview.campPreview &&
          campPreview.campPreview.stream_type === undefined ? (
          <h2 style={{ "text-align": " center" }} className="break-all">
            {preview.name ? null : <div className="flex items-center justify-center gap-4">
              <h3 className="text-center p-3 rounded-md break-all"  >{campPreview.campPreview.name}</h3>
              {campPreview.campPreview.name && <SlIcon library="lucide" name="copy" slot="prefix" className="px-2 py-1 w-6 h-6  rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150 flex-shrink-0" data-toggle="tooltip" title="copy creative name" onClick={() => copyToClipboard(preview)}></SlIcon>}
            </div>}
          </h2>
          // unnecessary name render
        ) : null} */}
        {preview?.sub_type === "full_image" && (
          <FullImagePreview preview={preview} />
        )}
        {preview?.sub_type === "webviewad" && (
          <WebviewPreview preview={preview} />
        )}
        {showPreview && preview?.sub_type === "gallery" && (
          <GalleryPreview preview={preview} edit={true} />
        )}
        {showPreview && preview?.sub_type === "full_video" && (
          <FullVideoPreview preview={preview} />
        )}
        {showPreview && preview?.sub_type === "half_video" && (
          <HalfVideoPreview preview={preview} />
        )}
        {preview?.sub_type === "video_with_bg" && (
          <VideowithBgPreview preview={preview} />
        )}
        {preview?.sub_type === "promoted_image_story" && (
          <PromotedImagePreview preview={preview} />
        )}
        {showPreview && preview?.sub_type === "promoted_video_story" && (
          <PromotedVideoPreview preview={preview} />
        )}
        {showPreview && preview?.sub_type === "fullvideo_or_gif" && (
          <AnimationPreview preview={preview} />
        )}
        {showPreview && preview?.sub_type === "promoted_gallery" && (
          <PromotedGalleryPreview preview={preview} edit={true} />
        )}
        {showPreview && preview?.sub_type === undefined && (
          <NetworkAdPreview preview={preview} />
        )}
        {showPreview && preview?.sub_type === "commentad" && (
          <CommentAdPreview preview={preview} />
        )}
        {showPreview && preview?.sub_type === "video_gallery" && (
          <VideoGalleryPreview preview={preview} />
        )}
        {showPreview && preview?.sub_type === "text_gallery" && (
          <TextGalleryPreview preview={preview} />
        )}
        {showPreview && (preview?.sub_type === "search" || preview?.sub_type === "unread") && (
          <BrandAdImagePreview preview={preview} />
        )}
        {showPreview && preview?.sub_type === "news_image_flip" && (
          <NewsImageFlip preview={preview} />
        )}
        {showPreview && preview?.sub_type === "news_image_logo" && (
          <NewsImageLogo preview={preview} />
        )}
        {showPreview && preview?.sub_type === "news_short_desc" && (
          <NewsImageDesc preview={preview} />
        )}
        {showPreview && preview?.sub_type === "video_expandable" && (
          <VideoExpandable key={Date.now()} preview={preview} />
        )}
        {showPreview && preview?.sub_type === "video_endcard" && (
          <VideoEndcard key={Date.now()} preview={preview} />
        )}
        {showPreview && preview?.sub_type === "video_skippable" && (
          <VideoSkippable preview={preview} />
        )}
        {showPreview && preview?.sub_type === "bottom_rectangle" && (
          <BottomRectangle key={Date.now()} preview={preview} />
        )}
          {showPreview && preview?.sub_type === "square_classified" && (
          <SquareClassified preview={preview} />
        )}
        {showPreview &&  preview?.sub_type === "rectangle_classified" && (
          <RectangleClassifieds preview={preview} />
        )}
        {showPreview && preview?.sub_type === "framepost" && (
          <FramePostPreview preview={preview} />
        )}
        {showPreview && preview?.sub_type === "rec_image" && (
          <RecImagePreview preview={preview} />
        )}
        {
          showPreview && preview?.sub_type === "rec_promoted_story" && (
            <RecPromotedPreview preview={preview} />
          )
        }
        {(showPreview && preview?.sub_type === "job_listings" &&
          
          <ListingsPreview preview={preview} />
        )}
        {
          showPreview && preview?.sub_type === "business_listings" && (
            <BusinessListingsPreview preview={preview} />
          )
        }
        {showPreview && preview?.sub_type === "specials" && (
          <SpecialsPreview preview={preview} />
        )}
        
      </section>
    </div>
  );
}

export default PreviewFrameEdit;
